import { mockRevision } from '../../mocks/mockRevision';

export const getParsedRevision = (revision = null) => {
  const revisionData = revision || mockRevision;

  const components = Object.entries(revisionData.components || {}).map(([componentName, componentData]) => {
    const { componentVersion, configurationUpdate = {}, description, lastStatusChangeTimestamp, lastStatusChangeAt } = componentData;

    let parameters = {};
    if (configurationUpdate.merge) {
      try {
        parameters = JSON.parse(configurationUpdate.merge);
      } catch (e) {
        parameters = {};
      }
    }

    return {
      name: componentName,
      version: componentVersion,
      parameters,
      description,
      lastStatusChangeTimestamp,
      lastStatusChangeAt,
    };
  });

  return {
    revisionId: revisionData.revisionId,
    deploymentName: revisionData.deploymentName,
    deploymentStatus: revisionData.deploymentStatus,
    components,
  };
};
